import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ServiceHeader from "../components/ServiceHeader";
import about_img from "../static/img/team.png";
import "../static/css/About.css";

function AboutPage() {
    return (
        <>
            <Nav />
            <ServiceHeader
                image={about_img}
                title={"About Us"}
                description={""}
            />

            {/* Main Content Section */}
            <div className="about-content">
                <div className="about-container">
                    {/* Introductory Text */}
                    <div className="about-intro">
                        <p>
                            SPP Insolvency Professionals LLP is a registered Insolvency Professional Entity (IPE)
                            under IBBI, built on the legacy of SPP & Co.'s insolvency practice since 2017. With over
                            40 mandates across 20+ sectors, we specialize in CIRP, liquidation, and distressed asset
                            recovery. Our multidisciplinary team of Chartered Accountants, Company Secretaries, retired
                            bankers, and legal counsels delivers strategic, compliant, and investor-ready solutions for
                            stressed entities.
                        </p>
                    </div>

                    {/* Our Firm Section */}
                    <div className="our-firm-section">
                        <h2>Our Firm</h2>
                        <p className="firm-subtitle">[The SPP Insolvency Professionals LLP Story]</p>

                        <div className="firm-points">
                            {/* Point 1 */}
                            <div className="firm-point">
                                <h3>• The SPP Insolvency Professionals LLP Story</h3>
                                <p>
                                    SPP Insolvency Professionals LLP is a registered Insolvency Professional Entity (IPE)
                                    under the Insolvency and Bankruptcy Board of India (IBBI), formed in 2022 through the
                                    strategic demerger of SPP & Co.'s insolvency practice. With a legacy of handling 40+
                                    IBC mandates across 20+ sectors, we deliver resolution, revival, and liquidation services
                                    with precision and regulatory integrity.
                                </p>
                            </div>

                            {/* Point 2 */}
                            <div className="firm-point">
                                <h3>• Our Reach</h3>
                                <p>
                                    Headquartered in Coimbatore, Tamil Nadu, we operate across South India with offices in
                                    Chennai, Bangalore, and Kochi. Our strong regional presence enables us to manage CIRP
                                    and liquidation assignments with local insight and national compliance.
                                </p>
                            </div>

                            {/* Point 3 */}
                            <div className="firm-point">
                                <h3>• Our Credentials</h3>
                                <ul>
                                    <li>– IBBI Registered IPE: IBBI/IPE/0143</li>
                                    <li>– Empanelled with major banks: SBI, PNB, BoB, Union Bank, Canara Bank, and more</li>
                                    <li>– Infrastructure: 4500 sq. ft. office space, 60+ seats, 55 full-time staff</li>
                                    <li>– Technical team: 9 CAs, 3 CSs, 2 retired bankers, 5 legal counsels</li>
                                </ul>
                            </div>

                            {/* Point 4 */}
                            <div className="firm-point">
                                <h3>• Our Approach</h3>
                                <p>
                                    We combine strategic advisory with operational execution—offering end-to-end insolvency
                                    services including CIRP management, Liquidation, Individual Insolvency & Bankruptcy,
                                    forensic audits, investor coordination, Plan preparation services, IM Preparation Services,
                                    Due Diligence Services and compliance controls. Our emphasis on transparency, stakeholder
                                    alignment, and revival potential makes us a preferred resolution partner.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default AboutPage;
